import React from "react";
import Loader from '../lib/ui/loader/Loader';

const Loading = (props) => {
    return <Loader />
}

export default Loading;
